import React from 'react';
import { Link } from 'react-router-dom';
import { Professor } from '../../services/professorService';

interface ProfessorCardProps {
  professor: Professor;
}

const ProfessorCard: React.FC<ProfessorCardProps> = ({ professor }) => {
  return (
    <div className="professor-card">
      <div className="professor-card-header">
        <h3 className="professor-name">{professor.name || (professor.email ? professor.email.split('@')[0] : 'Professor')}</h3>
        <p className="professor-title">{professor.title || 'Professor'}</p>
      </div>
      <div className="professor-card-body">
        <p className="university">
          <i className="bi bi-building me-2"></i>
          {professor.university || 'Unknown University'}
        </p>
        <p className="department">
          <i className="bi bi-diagram-3 me-2"></i>
          {professor.department || 'Unknown Department'}
        </p>
        <p className="research-summary">
          <i className="bi bi-lightbulb me-2"></i>
          {professor.research_summary || 'No research summary available'}
        </p>
        <div className="mt-2">
          {professor.research_areas && professor.research_areas.map((area, idx) => (
            <span key={idx} className="badge bg-light text-primary me-1 mb-1">{area}</span>
          ))}
        </div>
      </div>
      <div className="professor-card-footer">
        <Link to={`/professors/${professor.id}`} className="btn btn-primary">
          View Profile
        </Link>
        <a href={`mailto:${professor.email}`} className="btn btn-outline-primary">
          <i className="bi bi-envelope"></i>
        </a>
        <a href={professor.webpage || '#'} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">
          <i className="bi bi-globe"></i>
        </a>
      </div>
    </div>
  );
};

export default ProfessorCard;
